<template>
  <div class="admin-room-container figma-property-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">{{ $t('applyExperience.pageTitle') }}</div>
        <div class="figma-header-divider"></div>
        <div class="figma-header-row">
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn-refresh" title="刷新" @click="_queryMethod">
              <i class="el-icon-refresh"></i>
            </el-button>
          </div>
          <div class="figma-search-group">
            <el-input
              v-model="conditions.keyword"
              size="small"
              :placeholder="$t('applyExperience.search.keywordPlaceholder')"
              class="figma-search-input"
              clearable
              @keyup.enter.native="_queryMethod"
            />
            <el-input
              v-model="conditions.userPhone"
              size="small"
              :placeholder="$t('applyExperience.search.phonePlaceholder')"
              class="figma-search-input"
              clearable
              @keyup.enter.native="_queryMethod"
            />
            <el-button size="small" class="figma-btn-search" @click="_queryMethod">
              <i class="el-icon-search"></i>{{ $t('common.search') }}
            </el-button>
          </div>
        </div>
      </div>

      <div class="figma-table-section">
        <el-table
          :data="tableData"
          style="width: 100%"
          height="550"
          :fit="true"
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
        >
          <el-table-column prop="applyId" :label="$t('applyExperience.table.id')" min-width="70" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.applyId || scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="communityName" :label="$t('applyExperience.table.communityName')" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.communityName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="communityAreaLocation" :label="$t('applyExperience.table.communityAreaLocation')" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">{{ _getCommunityLocation(scope.row) }}</template>
          </el-table-column>
          <el-table-column prop="userName" :label="$t('applyExperience.table.userName')" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.userName || scope.row.name || '-' }}</template>
          </el-table-column>
          <el-table-column prop="userPhone" :label="$t('applyExperience.table.userPhone')" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.userPhone || scope.row.tel || scope.row.phone || '-' }}</template>
          </el-table-column>
          <el-table-column prop="userIdentity" :label="$t('applyExperience.table.userIdentity')" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{ getUserIdentityText(scope.row.userIdentity || scope.row.identity) }}</template>
          </el-table-column>
          <el-table-column prop="applyRemark" :label="$t('applyExperience.table.applyRemark')" min-width="220" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.applyRemark || scope.row.remark || '-' }}</template>
          </el-table-column>

          <el-table-column prop="state" :label="$t('applyExperience.table.state')" min-width="220" show-overflow-tooltip>
            <template slot-scope="scope"><span :class="['status-tag', getAuditStateClass(scope.row.statusCd)]">{{ getAuditStateText(scope.row.statusCd) }}</span></template>
          </el-table-column>
          <el-table-column prop="auditRemark" :label="$t('applyExperience.table.auditRemark')" min-width="220" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.auditRemark || '-' }}</template>
          </el-table-column>

          <el-table-column prop="createTime" :label="$t('applyExperience.table.applyTime')" min-width="180" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.createTime || scope.row.applyTime || '-' }}</template>
          </el-table-column>
          <el-table-column :label="$t('common.operation')" min-width="130">
            <template slot-scope="scope">
              <span v-if="String(scope.row.statusCd) === '0'" class="action-links">
                <el-tooltip content="请在用户管理页面添加该小区的业委会或者物业成员实现小区入驻！" placement="top">
                <a class="action-link" @click="_approveRow(scope.row)">{{ $t('applyExperience.action.approve') }}</a>
                </el-tooltip>
                <a class="action-link" @click="_rejectRow(scope.row)">{{ $t('applyExperience.action.reject') }}</a>
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="figma-pagination">
        <span class="pagination-total">共{{ pagination.total }}条</span>
        <el-pagination
          :current-page="pagination.current"
          :page-size="pagination.size"
          layout="prev, pager, next"
          :total="pagination.total"
          :pager-count="7"
          @current-change="handleCurrentChange"
        />
        <el-select v-model="pagination.size" size="small" class="pagination-size-select" @change="handleSizeChange">
          <el-option label="10条/页" :value="10" />
          <el-option label="20条/页" :value="20" />
          <el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>

    <el-dialog
      :visible.sync="approveDialogVisible"
      width="650px"
      top="39.7vh"
      :show-close="false"
      custom-class="apply-admin-dialog"
      :close-on-click-modal="false"
      @close="_resetApproveDialog"
    >
      <div slot="title" class="apply-dialog-header">
        <span class="apply-dialog-title">{{ $t('applyExperience.approveDialog.title') }}</span>
        <img src="/assets/CodeBuddyAssets/1669_8498/35.svg" class="apply-dialog-divider" />
      </div>
      <el-form ref="approveForm" :model="approveForm" :rules="approveRules" class="apply-admin-form" label-width="96px" size="small">
        <el-form-item :label="$t('applyExperience.approveDialog.adminLabel') + ':'" prop="adminUserIds" required>
          <el-select
            v-model="approveForm.adminUserIds"
            :placeholder="$t('applyExperience.approveDialog.selectPlaceholder')"
            class="apply-admin-select"
            multiple
            filterable
            clearable
            :loading="adminUserLoading"
            @visible-change="handleAdminVisibleChange"
          >
            <el-option
              v-for="item in adminUserOptions"
              :key="item.optionValue"
              :label="item.optionLabel"
              :value="item.optionValue"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="apply-dialog-footer">
        <el-button size="small" class="apply-btn-cancel" @click="approveDialogVisible = false">
          {{ $t('applyExperience.audit.cancel') }}
        </el-button>
        <el-button size="small" class="apply-btn-confirm" :loading="approveSubmitting" @click="_confirmApprove">
          {{ $t('common.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listCommunityExperienceApplys, auditCommunityExperienceApply, listUserManagement } from '@/api/platform/platformApi'
import { getAreaTree } from '@/api/community/cityAreaApi'

export default {
  name: 'ApplyExperienceList',
  data() {
    return {
      conditions: { keyword: '', userPhone: '' },
      tableData: [],
      areaCodeMap: {},
      pagination: { current: 1, size: 10, total: 0 },
      approveDialogVisible: false,
      approveSubmitting: false,
      approvingRow: null,
      approveForm: { adminUserIds: [] },
      approveRules: {
        adminUserIds: [{ required: true, message: this.$t('applyExperience.approveDialog.adminRequired'), trigger: 'change' }]
      },
      adminUserOptions: [],
      adminUserLoading: false
    }
  },
  created() {
    this._listData(this.pagination.current, this.pagination.size)
    this._loadAreaTree()
  },
  methods: {
    _loadAreaTree() {
      getAreaTree().then(res => {
        const root = res && res.data
        const map = {}
        this._buildAreaCodeMap(root, map)
        this.areaCodeMap = map
      }).catch(error => {
        console.error('查询地区树失败', error)
      })
    },
    _buildAreaCodeMap(node, map) {
      if (!node) return
      if (node.areaCode) {
        map[node.areaCode] = node.text || node.areaName || ''
      }
      if (Array.isArray(node.children)) {
        node.children.forEach(child => this._buildAreaCodeMap(child, map))
      }
    },
    _getCommunityLocation(row) {
      if (!row) return '-'
      const cityCode = row.cityCodeNew || row.cityCode || ''
      const districtCode = row.districtCode || ''
      const cityName = (cityCode && this.areaCodeMap[cityCode]) || ''
      const districtName = (districtCode && this.areaCodeMap[districtCode]) || ''
      const parts = [cityName, districtName].filter(Boolean)
      return parts.length ? parts.join('') : '-'
    },
    _listData(page, size) {
      const keyword = (this.conditions.keyword || '').trim()
      const userPhone = (this.conditions.userPhone || '').trim()
      const params = { page, row: size }
      if (keyword) params.name = keyword
      if (userPhone) params.userPhone = userPhone
      listCommunityExperienceApplys(params).then(res => {
        const list = Array.isArray(res.data) ? res.data : (Array.isArray(res.records) ? res.records : [])
        this.tableData = list
        this.pagination.total = res.total || res.totalCount || res.count || list.length || 0
      }).catch(error => {
        console.error('请求失败处理', error)
      })
    },
    _queryMethod() {
      this.pagination.current = 1
      this._listData(this.pagination.current, this.pagination.size)
    },
    _approveRow(row) {
      // const confirmContent = `请确认已经为该小区添加了业委会成员？<a href="#/pages/platform/userManagement" class="jump-link" style="color: #0E76FF; text-decoration: underline;">请去用户管理</a>为该小区添加业委会成员。`
      // this.$confirm(confirmContent, this.$t('applyExperience.audit.approveTitle'), {
      //   confirmButtonText: this.$t('applyExperience.action.approve'),
      //   cancelButtonText: this.$t('applyExperience.audit.cancel'),
      //   type: 'warning',
      //   dangerouslyUseHTMLString: true
      // }).then(() => {
      //   this.approveSubmitting = true
      //   return auditCommunityExperienceApply({
      //     applyId: row.applyId,
      //     statusCd: '1',
      //     auditRemark: this.$t('applyExperience.audit.defaultApproveRemark')
      //   })
      // }).then(() => {
      //   this.$message.success(this.$t('applyExperience.audit.approveSuccess'))
      //   this.$router.push('/pages/platform/userManagement')
      // }).catch(error => {
      //   if (error === 'cancel' || error === 'close') return
      //   console.error('审核失败', error)
      //   this.$message.error(error.message || this.$t('applyExperience.audit.approveFail'))
      // }).finally(() => {
      //   this.approveSubmitting = false
      // })
      this.$router.push('/pages/platform/userManagement')
    },
    _confirmApprove() {
      if (!this.approvingRow) return
        const params = {
          applyId: this.approvingRow.applyId,
          statusCd: '1',
          auditRemark: this.$t('applyExperience.audit.defaultApproveRemark')
        }
        this.approveSubmitting = true
        auditCommunityExperienceApply(params).then(() => {
          this.$message.success(this.$t('applyExperience.audit.approveSuccess'))
          this.approveDialogVisible = false
          this._queryMethod()
        }).catch(error => {
          console.error('审核失败', error)
          this.$message.error(error.message || this.$t('applyExperience.audit.approveFail'))
        }).finally(() => {
          this.approveSubmitting = false
        })
    },
    _rejectRow(row) {
      this.$prompt(this.$t('applyExperience.audit.rejectConfirm'), this.$t('applyExperience.audit.rejectTitle'), {
        confirmButtonText: this.$t('applyExperience.action.reject'),
        cancelButtonText: this.$t('applyExperience.audit.cancel'),
        inputPlaceholder: this.$t('applyExperience.audit.remarkPlaceholder'),
        inputValue: this.$t('applyExperience.audit.defaultRejectRemark')
      }).then(({ value }) => {
        const params = {
          applyId: row.applyId,
          statusCd: '2',
          auditRemark: value || this.$t('applyExperience.audit.defaultRejectRemark'),
          userId: row.userId || ''
        }
        auditCommunityExperienceApply(params).then(() => {
          this.$message.success(this.$t('applyExperience.audit.rejectSuccess'))
          this._queryMethod()
        }).catch(error => { console.error('审核失败', error) })
      }).catch(() => {})
    },
    handleAdminVisibleChange(visible) {
      if (visible) this.loadAdminUsers()
    },
    async loadAdminUsers() {
      if (this.adminUserLoading) return
      this.adminUserLoading = true
      try {
        const res = await listUserManagement({ page: 1, row: 1000 })
        const list = this.normalizeUserList(res)
        this.adminUserOptions = list.map(item => {
          const userId = item.userId || item.id || item.user_id || item.staffId || item.memberId
          const user = { ...item, userId }
          return {
            ...user,
            optionValue: userId ? String(userId) : '',
            optionLabel: this.getUserDisplayName(user)
          }
        }).filter(item => item.optionValue)
      } catch (error) {
        console.error('查询用户失败', error)
        this.$message.error(error.message || this.$t('applyExperience.approveDialog.loadUserError'))
      } finally {
        this.adminUserLoading = false
      }
    },
    normalizeUserList(res) {
      if (Array.isArray(res)) return res
      if (!res) return []
      if (Array.isArray(res.users)) return res.users
      if (Array.isArray(res.data)) return res.data
      if (Array.isArray(res.records)) return res.records
      if (Array.isArray(res.rows)) return res.rows
      if (res.data && Array.isArray(res.data.records)) return res.data.records
      if (res.data && Array.isArray(res.data.list)) return res.data.list
      return []
    },
    getUserDisplayName(user) {
      if (!user) return '-'
      return user.userName || user.name || user.staffName || user.nickName || user.userId || '-'
    },
    _resetApproveDialog() {
      this.approveForm.adminUserIds = []
      this.approvingRow = null
      this.approveSubmitting = false
      this.$nextTick(() => {
        if (this.$refs.approveForm) this.$refs.approveForm.clearValidate()
      })
    },
    getAuditStateClass(status) {
      return { '0': 'status-warning', '1': 'status-normal', '2': 'status-danger' }[status] || 'status-warning'
    },
    getAuditStateText(status) {
      return { '0': this.$t('applyExperience.table.statePending'), '1': this.$t('applyExperience.table.stateApproved'), '2': this.$t('applyExperience.table.stateRejected') }[status] || '-'
    },
    getUserIdentityText(identity) {
      const value = identity == null ? '' : String(identity)
      return {
        '1': this.$t('applyExperience.identity.owner'),
        '2': this.$t('applyExperience.identity.committee'),
        '3': this.$t('applyExperience.identity.property'),
        owner: this.$t('applyExperience.identity.owner'),
        committee: this.$t('applyExperience.identity.committee'),
        property: this.$t('applyExperience.identity.property')
      }[value] || value || '-'
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.pagination.current = 1
      this._listData(this.pagination.current, val)
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this._listData(val, this.pagination.size)
    },
    headerCellStyle() {
      return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '400', fontFamily: 'PingFang SC', height: '50px' }
    },
    cellStyle({ row }) {
      const rowIndex = this.tableData.indexOf(row)
      return rowIndex % 2 === 1
        ? { background: '#F8FBFF', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px' }
        : { background: 'white', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px' }
    }
  }
}
</script>

<style scoped>
.admin-room-container { height: calc(100vh - 92px); background: #EBF2FA; padding: 0; overflow: hidden; box-sizing: border-box; display: flex; flex-direction: column; }
.figma-white-card { background: #FFFFFF; border-radius: 12px; flex: 1; min-height: 0; display: flex; flex-direction: column; }
.figma-page-header { display: flex; flex-direction: column; align-items: flex-start; padding: 20px 24px 24px; gap: 0; }
.figma-page-title { height: 22px; line-height: 22px; font-size: 16px; font-weight: 500; color: #1D2129; font-family: 'PingFang SC'; margin: 0 0 22px; }
.figma-header-divider { width: 100%; height: 1px; background: #DCE6F5; margin-bottom: 23px; }
.figma-header-row { display: flex; align-items: center; justify-content: space-between; width: 100%; height: 38px; }
.figma-btn-group { display: flex; align-items: center; gap: 8px; }
.figma-btn-refresh { height: 38px; width: 38px; padding: 0 !important; border-radius: 10px !important; border: none !important; outline: 1px solid #DCE6F5 !important; outline-offset: -1px; background: #FFFFFF !important; color: #6A7282 !important; display: inline-flex; align-items: center; justify-content: center; font-size: 16px; }
.figma-btn-refresh:hover { outline-color: #0E76FF !important; color: #0E76FF !important; }
.figma-search-group { display: flex; align-items: center; gap: 12px; margin-left: auto; }
.figma-search-input { width: 180px; height: 38px; }
.figma-search-input >>> .el-input__inner { border-radius: 10px; border: none; outline: 1px #DCE6F5 solid; outline-offset: -1px; height: 38px; line-height: 38px; padding: 0 16px; font-size: 14px; color: #1D2129; background: #FFFFFF; font-family: 'Inter', 'PingFang SC'; }
.figma-search-input >>> .el-input__inner::placeholder { color: #8C9BB4; }
.figma-search-input >>> .el-input__inner:focus { outline-color: #0E76FF; }
.figma-btn-search { width: 84px; height: 38px; border-radius: 10px !important; border: none !important; outline: 1px #0E76FF solid !important; outline-offset: -1px; color: #0E76FF !important; background: #FFFFFF !important; font-size: 14px; font-weight: 500; padding: 0 !important; display: inline-flex; align-items: center; justify-content: center; gap: 6px; font-family: 'Inter', 'PingFang SC'; }
.figma-btn-search:hover { background: rgba(14, 118, 255, 0.08) !important; }
.figma-table-section { flex: 0 0 550px; height: 550px; padding: 0 24px; overflow: auto; box-sizing: border-box; }
.figma-table-section >>> .el-table { border-radius: 0; overflow: hidden; border: none; color: #1D2129; font-family: 'PingFang SC'; }
.figma-table-section >>> .el-table__header th { background: #EBF2FA !important; border: none !important; padding: 0 !important; }
.figma-table-section >>> .el-table__body td { border: none !important; padding: 0 !important; }
.figma-table-section >>> .el-table__body tr:nth-child(even) td { background: #F8FBFF !important; }
.figma-table-section >>> .el-table::before,
.figma-table-section >>> .el-table__fixed-right::before,
.figma-table-section >>> .el-table__fixed::before { display: none; }
.figma-table-section >>> .el-table .cell { height: 50px; line-height: 22px; padding: 14px 24px !important; box-sizing: border-box; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.figma-table-section >>> .el-table__header .cell { color: #364153; font-weight: 400; }
.action-links { display: inline-flex; align-items: center; gap: 18px; height: 22px; }
.action-link { color: #0E76FF; font-size: 14px; line-height: 22px; font-weight: 500; cursor: pointer; text-decoration: none; font-family: 'PingFang SC'; }
.action-link:hover { color: #0E76FF; text-decoration: none; }
.status-tag { display: inline-block; padding: 3px 12px; border-radius: 8px; font-size: 14px; font-weight: 400; }
.status-normal { background: rgba(33, 185, 86, 0.10); color: #21B956; outline: 1px solid #21B956; outline-offset: -1px; }
.status-danger { background: rgba(251, 44, 54, 0.10); color: #FB2C36; outline: 1px solid #FB2C36; outline-offset: -1px; }
.status-warning { background: rgba(255, 153, 0, 0.10); color: #FF9900; outline: 1px solid #FF9900; outline-offset: -1px; }
.figma-pagination { display: flex; align-items: center; justify-content: flex-end; height: 32px; padding: 18px 19px 0 24px; gap: 8px; border-top: none; box-sizing: content-box; }
.pagination-total { font-size: 14px; line-height: 22px; color: #1D2129; font-family: 'PingFang SC'; margin-right: 0; }
.figma-pagination >>> .el-pagination { display: flex; align-items: center; padding: 0; color: #364153; font-weight: 600; }
.figma-pagination >>> .btn-prev,
.figma-pagination >>> .btn-next,
.figma-pagination >>> .el-pager li { min-width: 32px; width: 32px; height: 32px; line-height: 32px; border-radius: 2px; margin: 0 4px; padding: 0; background: transparent; color: #364153; font-family: 'Nunito Sans', 'PingFang SC'; font-size: 14px; font-weight: 600; }
.figma-pagination >>> .el-pager li.active { background: #E8F3FF; color: #0E76FF; }
.pagination-size-select { width: 92px; height: 32px; margin-left: 4px; }
.pagination-size-select >>> .el-input__inner { height: 32px; line-height: 32px; border-radius: 2px; background: #F2F3F5; border: none; font-size: 14px; color: #1D2129; padding: 0 28px 0 12px; }
.pagination-size-select >>> .el-input__suffix { right: 4px; }
.admin-room-container >>> .apply-admin-dialog { border-radius: 12px; overflow: hidden; background: #FFFFFF; box-shadow: 0 12px 32px rgba(10, 10, 20, 0.18); }
.admin-room-container >>> .apply-admin-dialog .el-dialog__header { padding: 0; }
.admin-room-container >>> .apply-admin-dialog .el-dialog__body { padding: 26px 24px 0 14px; }
.admin-room-container >>> .apply-admin-dialog .el-dialog__footer { padding: 26px 24px 28px; }
.apply-dialog-header { position: relative; height: 66px; background: #EBF2FA; border-radius: 12px 12px 0 0; box-sizing: border-box; }
.apply-dialog-title { position: absolute; left: 24px; top: 22px; font-size: 16px; line-height: 22px; font-weight: 600; color: #1D2129; font-family: 'PingFang SC'; }
.apply-dialog-divider { position: absolute; left: 0; bottom: 0; width: 100%; height: 1px; object-fit: cover; }
.apply-admin-form { margin: 0; }
.apply-admin-form >>> .el-form-item { margin-bottom: 0; }
.apply-admin-form >>> .el-form-item__label { height: 38px; line-height: 38px; padding-right: 0; font-size: 14px; font-weight: 500; color: #0A0A14; font-family: 'PingFang SC'; }
.apply-admin-form >>> .el-form-item.is-required .el-form-item__label::before { color: #FB2C36; margin-right: 0; }
.apply-admin-form >>> .el-form-item__content { line-height: 38px; }
.apply-admin-select { width: 516px; }
.apply-admin-select >>> .el-input__inner { min-height: 38px !important; line-height: 38px; border: none; border-radius: 10px; outline: 1px solid #DCE6F5; outline-offset: -1px; color: #1D2129; font-size: 14px; font-family: 'Inter', 'PingFang SC'; }
.apply-admin-select >>> .el-input__inner:focus { outline-color: #0E76FF; }
.apply-admin-select >>> .el-select__tags { max-width: 470px !important; }
.apply-admin-select >>> .el-tag { height: 26px; line-height: 24px; border: none; border-radius: 4px; background: #E7F1FF; color: #0A0A14; font-size: 14px; font-weight: 500; font-family: 'PingFang SC'; }
.apply-admin-select >>> .el-tag__close { color: #0A0A14; background: transparent; }
.apply-dialog-footer { display: flex; align-items: center; justify-content: flex-end; gap: 12px; }
.apply-btn-cancel,
.apply-btn-confirm { width: 98px; height: 38px; padding: 0 !important; border-radius: 10px !important; font-size: 14px; font-weight: 500; font-family: 'PingFang SC'; }
.apply-btn-cancel { background: #FFFFFF !important; border: none !important; outline: 1px solid #0E76FF !important; outline-offset: -1px; color: #0E76FF !important; }
.apply-btn-confirm { background: #0E76FF !important; border: none !important; color: #FFFFFF !important; }
@media (max-width: 1280px) {
  .figma-table-section { flex-basis: calc(100vh - 300px); height: calc(100vh - 300px); }
  .figma-search-group { gap: 8px; }
}
@media (max-width: 768px) {
  .figma-page-header { padding: 16px; }
  .figma-header-row { height: auto; flex-direction: column; align-items: stretch; gap: 12px; }
  .figma-search-group { width: 100%; flex-wrap: wrap; }
  .figma-search-input { flex: 1; min-width: 180px; }
  .figma-table-section { padding: 0 16px; }
  .figma-pagination { justify-content: flex-start; flex-wrap: wrap; padding: 16px; height: auto; }
}
</style>
